import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import axios from "axios";
import "../../../../assets/css/customer/publicCustomerCss/Testimonial/testimonial.css";
import AppContext from "../../../../context/AppContext";

const TestimonialPage = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [zoomedImg, setZoomedImg] = useState(null);
 const {baseUrl,imageBaseUrl}=useContext(AppContext);
  useEffect(() => {
    setLoading(true);
    axios.get( `${baseUrl}/customer/get-customer-reviews`)
      .then((res) => {
        if (res.data.success) {
          setTestimonials(res.data.reviews);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
  <header className="testimonials-page-hero">
  <div className="container" style={{ position: "relative", zIndex: 2 }}>
    <div className="testimonials-page-badge">NORTHERN PAKISTAN</div>
    <h1 className="testimonials-page-title">Customer Testimonials</h1>
    <p className="testimonials-page-subtitle">
      Real experiences from travelers who explored Northern Pakistan
    </p>
  </div>
<div className="testimonials-page-hero-wave">
  <svg viewBox="0 0 1440 20" preserveAspectRatio="none">
    <path d="M0,0 L1440,0 L1440,20 L0,20 Z" fill="#f2f5f8" />
  </svg>
</div>
</header>
      <main className="testimonials-page-content">
        <Container>
          {loading ? (
            <div className="testimonials-page-loading">
              <div className="testimonials-page-spinner"></div>
              <p>Loading stories...</p>
            </div>
          ) : (
            <section className="testimonials-page-grid">
              <Row xs={1} md={2} lg={3} className="g-4">
                {testimonials.map((review) => (
                  <Col key={review.id}>
                    <div className="testimonials-page-card">
                      <div className="testimonials-page-card-header">
                        <div className="testimonials-page-avatar-placeholder">
                          <i className="fas fa-user"></i>
                        </div>
                        <div className="testimonials-page-card-info">
                          <h3 className="testimonials-page-card-name">
                            {review.jjbooking?.jjcustomer?.cus_username || "—"}
                          </h3>
                          <p className="testimonials-page-card-location">
                            {review.jjbooking?.jjcustomer?.cus_email || "—"}
                          </p>
                          <div className="testimonials-page-card-rating">
                            {[...Array(5)].map((_, i) => (
                              <span key={i} className={i < review.rating ? "star-filled" : "star-empty"}>
                                ★
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>

                      <div className="testimonials-page-card-body">
                        <p className="testimonials-page-card-text">
                          {review.review_message || 'No message provided.'}
                        </p>

                        {review.image && (
                          <div className="testimonials-page-img-wrap">
                            <div className="testimonials-page-img-thumb-wrap">
                              <img
                              src={`${imageBaseUrl}/${review.image}`}
                                alt="Review"
                                className="testimonials-page-img-thumb"
                              onClick={() => setZoomedImg(`${imageBaseUrl}/${review.image}`)}
                                onError={(e) => { e.target.parentElement.style.display = "none"; }}
                              />
                              <div
                                className="testimonials-page-img-overlay"
                                 onClick={() => setZoomedImg(`${imageBaseUrl}/${review.image}`)}                              >
                                <i className="fas fa-search-plus"></i>
                              </div>
                            </div>
                          </div>
                        )}

                        <div className="testimonials-page-card-footer">
                         
                          <span className="testimonials-page-card-date">
                            {new Date(review.created_at).toLocaleDateString()}
                          </span>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </section>
          )}

          {!loading && testimonials.length === 0 && (
            <div className="testimonials-page-end">
              <p>No reviews found.</p>
            </div>
          )}
        </Container>
      </main>

      {zoomedImg && (
        <div className="testimonials-page-zoom-backdrop" onClick={() => setZoomedImg(null)}>
          <div className="testimonials-page-zoom-box" onClick={(e) => e.stopPropagation()}>
            <button className="testimonials-page-zoom-close" onClick={() => setZoomedImg(null)}>✕</button>
            <img src={zoomedImg} alt="Zoomed" className="testimonials-page-zoom-img" />
          </div>
        </div>
      )}
    </>
  );
};

export default TestimonialPage;